module.exports = __webpack_public_path__ + "img/MapThumb_FourLakes.7fe2ef4c.webp";